import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'

const Clickable = forwardRef(({
  to,
  href,
  ...props
}, ref) => {
  if (to) {
    return (
      <Link
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        to={to}
        ref={ref}
      />
    )
  }
  if (href) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      <a
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        href={href}
        ref={ref}
      />
    )
  }
  return (
    <button
      type="button"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      ref={ref}
    />
  )
})

Clickable.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
  })]),
  href: PropTypes.string,
}

Clickable.defaultProps = {
  to: null,
  href: null,
}

export default Clickable
